export default "__VITE_ASSET__CUjc9wOz__"